<div class="oauth-consent">
  <div class="consent-card">
    <h1>Connect to MediaBlast</h1>
    <p class="lead">
      <strong>{{ clientName }}</strong> wants to access your Adcore Marketing Cloud account<span *ngIf="email"> as <strong>{{ email }}</strong></span>.
    </p>
    <!-- Diagnostic only, visible without opening DevTools: the pending-info
         lookup itself failed (network/auth/CORS) rather than resolving to a
         known/unknown client name. -->
    <p class="lookup-hint" *ngIf="clientNameError">Client name lookup failed ({{ clientNameError }}).</p>
    <p class="scope">
      This grants <strong>read-only</strong> access to your MediaBlast wallet, plan, transactions,
      account limits, and ad accounts. It cannot move funds or change anything.
    </p>

    <div class="error" *ngIf="errorMsg">{{ errorMsg }}</div>

    <div class="actions">
      <button type="button" class="btn btn-deny" (click)="deny()" [disabled]="submitting">
        {{ denying ? 'Denying…' : 'Deny' }}
      </button>
      <button type="button" class="btn btn-allow" (click)="allow()" [disabled]="submitting || !requestId">
        {{ submitting && !denying ? 'Authorizing…' : 'Allow' }}
      </button>
    </div>
  </div>
</div>
